// @ts-check

import Link from '../Link/Link';

/**
 *
 * @param {object} props
 * @param {string} [props.to]
 * @param {boolean} [props.isActive]
 * @param {() => void} [props.onClick]
 * @param {boolean} [props.exact]
 * @param {string} [props.className]
 * @param {React.ReactNode} props.children
 * @returns {JSX.Element}
 */
export default function TabbedMenuItem({
  to,
  children,
  isActive,
  onClick,
  exact,
  className,
  ...rest
}) {
  // Check if the item is the active route.
  const isRouteActive = true; // Boolean(matchPath(':something', to));
  const isDisplayingAsActive =
    typeof isActive == 'boolean' ? isActive : isRouteActive;
  return (
    <Link
      to={to}
      onClick={onClick}
      variant="menu"
      sx={{
        borderColor: isDisplayingAsActive && 'primary',
        color: isDisplayingAsActive ? 'inherit' : 'lightText',
        variant: 'label.default',
        ':hover': { color: to ? undefined : 'inherit' },
        ':focus': { outline: 'none' },
      }}
      aria-current={isDisplayingAsActive ? 'page' : undefined}
      className={className}
      {...rest}
    >
      {children}
    </Link>
  );
}
